
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools-methods/[slug]",
      function () {
        return require("private-next-pages/tools-methods/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools-methods/[slug]"])
      });
    }
  